/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlZeroDayAlertNotificationSearchResult
 */
export interface ControlZeroDayAlertNotificationSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertNotificationSearchResult
     */
    zero_day_alert_id: string;
    /**
     * 
     * @type {number}
     * @memberof ControlZeroDayAlertNotificationSearchResult
     */
    alert_version: number;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertNotificationSearchResult
     */
    event_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertNotificationSearchResult
     */
    sent: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertNotificationSearchResult
     */
    email_subject: string;
    /**
     * 
     * @type {number}
     * @memberof ControlZeroDayAlertNotificationSearchResult
     */
    num_clients: number;
}

/**
 * Check if a given object implements the ControlZeroDayAlertNotificationSearchResult interface.
 */
export function instanceOfControlZeroDayAlertNotificationSearchResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zero_day_alert_id" in value;
    isInstance = isInstance && "alert_version" in value;
    isInstance = isInstance && "event_id" in value;
    isInstance = isInstance && "sent" in value;
    isInstance = isInstance && "email_subject" in value;
    isInstance = isInstance && "num_clients" in value;

    return isInstance;
}

export function ControlZeroDayAlertNotificationSearchResultFromJSON(json: any): ControlZeroDayAlertNotificationSearchResult {
    return ControlZeroDayAlertNotificationSearchResultFromJSONTyped(json, false);
}

export function ControlZeroDayAlertNotificationSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertNotificationSearchResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zero_day_alert_id': json['zero_day_alert_id'],
        'alert_version': json['alert_version'],
        'event_id': json['event_id'],
        'sent': json['sent'],
        'email_subject': json['email_subject'],
        'num_clients': json['num_clients'],
    };
}

export function ControlZeroDayAlertNotificationSearchResultToJSON(value?: ControlZeroDayAlertNotificationSearchResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zero_day_alert_id': value.zero_day_alert_id,
        'alert_version': value.alert_version,
        'event_id': value.event_id,
        'sent': value.sent,
        'email_subject': value.email_subject,
        'num_clients': value.num_clients,
    };
}

